import http from '../util/request.js'

export const getList = (params) =>{
	return http({
		url:'/apistore/product/list',
		data:params,
		method:'get'
	})
}
export const ratingList = (params) =>{
	return http({
		url:'/apistore/product/ratingList',
		data:params,
		method:'get'
	})
}
